import axios from 'axios'
import { vendorUrl, getHeader, vendorTypeUrl, purchasingUrl } from '@/config'

const state = {
  vendorList: [],
  vendorTypeList: [],
  vendorOrderList: [],
  vendorOutstandingList: []
}

const mutations = {
  SET_VENDOR_LIST (state, obj) {
    state.vendorList = obj
  },
  SET_VENDOR_TYPE_LIST (state, obj) {
    state.vendorTypeList = obj
  },
  SET_VENDOR_ORDER_LIST (state, obj) {
    state.vendorOrderList = obj
  },
  SET_VENDOR_OUTSTANDING_LIST (state, obj) {
    state.vendorOutstandingList = obj
  }
}

const actions = {
  getVendorOutstanding: ({ commit }, payload) => {
    // var data = {
    //   vendor_no: this.payment.vendor_no,
    //   year: this.payment.payment_date,
    //   company_no: this.payment.company_no
    // }
    console.log(payload)
    console.log(purchasingUrl + '/vendor/outstanding')
    axios.post(purchasingUrl + '/vendor/outstanding', payload, { headers: getHeader() })
      .then(response => {
        commit('SET_VENDOR_OUTSTANDING_LIST', response.data.data)
      })
  },
  getVendorOrderList: ({ commit }, payload) => {
    axios.post(vendorUrl + '/order', payload, { headers: getHeader() })
      .then(response => {
        commit('SET_VENDOR_ORDER_LIST', response.data.data)
      })
  },
  getVendorList: ({ commit }) => {
    axios.get(vendorUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_VENDOR_LIST', response.data.data)
      })
  },
  getvendorTypeList: ({ commit }) => {
    axios.get(vendorTypeUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_VENDOR_TYPE_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
